/* eslint-disable global-require */
import { configureStore as createToolkitStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { createReduxHistoryContext } from 'redux-first-history';
import { APP_BASE } from '../constants/branding';
import createRootReducer from '../reducers';
import getSagas, { createDynamicSaga } from '../sagas';
import createLogger from './logger';

const DEBUG = process.env.NODE_ENV !== 'production';

const sagaMiddleware = createSagaMiddleware();
const logger = createLogger();

export default function configureStore(
  history,
  initialState,
  basename = APP_BASE
) {
  const {
    createReduxHistory,
    routerMiddleware,
    routerReducer,
  } = createReduxHistoryContext({
    history,
    basename,
  });

  const middlewareList = [
    sagaMiddleware,
    routerMiddleware,
    DEBUG && logger,
  ].filter(Boolean);

  const store = createToolkitStore({
    reducer: createRootReducer(routerReducer, basename),
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: true,
        serializableCheck: false,
        immutableCheck: false,
      }).concat(middlewareList),
    devTools: DEBUG,
  });

  store.reduxHistory = createReduxHistory(store);

  sagaMiddleware.run(createDynamicSaga('SET_SAGAS', getSagas()));

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextReducerModule = require('../reducers/index');
      const rootReducer = nextReducerModule.default || nextReducerModule;
      store.replaceReducer(rootReducer(routerReducer, basename));
    });

    module.hot.accept('../sagas', () => {
      const getNewSagas = require('../sagas/index');
      store.dispatch({ type: 'SET_SAGAS', sagas: getNewSagas() });
    });
  }

  return store;
}
